import type { BusinessUser, UserBusinessRole } from "lens-platform-sdk";
import { LensSDKException } from "lens-platform-sdk";
import { useQuery } from "@tanstack/react-query";
import { useLensPlatformClient } from "./useLensPlatformClient";

/**
 * Get users for a business by role and by id
 */
function useGetBusinessUsers(businessId?: string, role?: UserBusinessRole) {
  const lensPlatformClient = useLensPlatformClient();

  const {
    isLoading: loading, error, data: businessUsers, refetch
  } = useQuery<BusinessUser[], LensSDKException>({
    queryKey: ["businessUsers", businessId, role],
    queryFn: async () => {
      if (!businessId) return [];
      const users = await lensPlatformClient.business.getUsers(businessId);

      if (role) {
        return users.filter((user) => user.role === role);
      }

      return users;
    },
    initialData: []
  });

  return {
    loading,
    error,
    businessUsers,
    reload: refetch
  };
}

export { useGetBusinessUsers };
